import $ from 'jquery';
window.$ = window.jQuery = $;
// import 'slick-carousel';
import 'slick-carousel/slick/slick.min';

import headerSticky from './components/headerSticky';
import slickSlider from './components/slick-slider';
import thankYouPopup from './components/thankYouPopup';
import hamburger from './components/hamburger';
import countdown from './components/countdown';
import gallery from './components/gallery';
import loadMore from './components/loadMore';

$(function() {
    headerSticky.init();
    slickSlider.init();
    thankYouPopup.init();
    hamburger.init();
    countdown.init();
    loadMore.init();
});